import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 512 512" {...props}>
      <title>{props.title || 'Left-Open'}</title>
      <g>
        <path d="M106.9 275.1c-6.4-6.3-9.6-13.7-9.6-22s3.2-15.6 9.6-21.8l221.1-222.2c6.4-6.3 13.8-9.5 22.5-9.5 8.5 0 16 3.2 22.4 9.5l32.9 32.9c6.4 6.5 9.6 13.8 9.6 22.5 0 8.6-3.2 15.9-9.6 22l-167.5 168.1 167.4 164.8c6.4 6.3 9.6 13.6 9.6 21.9 0 8.2-3.2 15.5-9.6 21.9l-32.9 33.6c-6.4 6.3-13.9 9.5-22.4 9.5-8.6 0-16.1-3.2-22.5-9.5l-221-221.7z" />
      </g>
    </Icon>
  )
}
